// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__khAWt","frameSquare":"recentes_frameSquare__5lwxe","imagem":"recentes_imagem__3rwge","marca":"recentes_marca__EgZ-2","modelo":"recentes_modelo__ChALN"};